/**
 * NKBA API
 * The RESTful backend behind the NKBA application
 *
 * OpenAPI spec version: V1.0.0
 * Contact: cloud@nkba.org
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { AxiosRequestConfig } from 'axios';
import { axios } from '../axios.config';

import { ResultsDailyAccountSummaryObjectId } from '../models/ResultsDailyAccountSummaryObjectId';

/* tslint:disable:no-unused-variable member-ordering max-line-length */

export class ReportApiResource {

    /**
     * Return the account summaries for a particular date
     * 
     * @param date Date
     */
    public findAccountSummaryByDate(date: Partial<string>, axiosConfig?: AxiosRequestConfig): Promise<ResultsDailyAccountSummaryObjectId> {
        const reqPath = '/v1/report/account/{date}'
                    .replace('{' + 'date}', String(date));
        let reqConfig = {
            ...axiosConfig,
            method: 'GET',
            url: reqPath
        };
        return axios.request(reqConfig)
            .then(res => {
                return res.data;
            });
    }

}

export const ReportApi = new ReportApiResource();



// WEBPACK FOOTER //
// ./src/common/api/resources/ReportApi.ts